import { Component, OnInit, Inject, ViewChild,ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef,MatCalendar } from '@angular/material';
import { FormBuilder, Validators, FormGroup, ValidatorFn } from '@angular/forms';
import { CopyTemplateDialogModel } from '../models';
import { ToastrService } from 'ngx-toastr';
import { CalendarTemplate, CalendarTemplateDay } from 'src/app/models/CalendarTemplate';
import { DatePipe } from '@angular/common';
import { CalDatesService } from '../cal-dates.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Defaults } from 'src/app/Utilities/defaults';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import moment from 'moment';

@Component({
  selector: 'app-copy-template-dialog',
  templateUrl: './copy-template-dialog.component.html',
  styleUrls: ['./copy-template-dialog.component.css'],
  providers: [CalDatesService]
})
export class CopyTemplateDialogComponent implements OnInit {

  form: FormGroup;
  dialogInput: CopyTemplateDialogModel;
  public lstProviders: IUserDetails[];
  public recurrenceList = ['Daily', 'Custom', 'Custom-Series'];
  @ViewChild("calendar", { static: false }) caldr: ElementRef<MatCalendar<Date>>;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CopyTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: CopyTemplateDialogModel, private sharedService: SharedService, private toastr: ToastrService, public datepipe: DatePipe, private dateService: CalDatesService, private schedulerService: SchedularServiceService,
    ) {
    this.dialogInput = data;
    this.form = fb.group({
      chosenProvider: ['', [Validators.required]],
      chosenLocation: [0, [Validators.required, Validators.min(1)]],
      newTemplateName: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: [''],
      templateColor: [],
      // chosenRecurrence: [ '', [ Validators.required ] ],
      recurrenceList: [this.recurrenceList],
      chosenRecurrence: ['', [Validators.required]],
      dayMon: false,
      dayTue: false,
      dayWed: false,
      dayThu: false,
      dayFri: false,
      daySat: false,
      daySun: false,
      dayList: [],
    });
  }

  ngOnInit() {
  }

  get chosenProvider() { return this.form.get('chosenProvider'); }

  get chosenLocation() { return this.form.get('chosenLocation'); }

  get newTemplateName() { return this.form.get('newTemplateName'); }

  // public recurrenceList = ['Daily', 'Custom'];
  onrecurrenceselectionchange(event) {
    ;
    this.AlertMessage = '';
    if (this.form.value.chosenRecurrence != null) {
      if (this.form.value.chosenRecurrence == 'Daily') {
        this.displayDays = false;
        this.displaycuston = false;
        this.form.patchValue({
          dayMon: false,
          dayTue: false,
          dayWed: false,
          dayThu: false,
          dayFri: false,
          daySat: false,
          daySun: false,
          endDate: this.form.controls.startDate.value
        });
        this.daysSelected = [];
      }
      if (this.form.value.chosenRecurrence == 'Custom-Series') {
        this.displayDays = true;
        this.displaycuston = false;
        this.form.patchValue({
          dayMon: false,
          dayTue: false,
          dayWed: false,
          dayThu: false,
          dayFri: false,
          daySat: false,
          daySun: false,
        });
        this.daysSelected = [];
      }
      if (this.form.value.chosenRecurrence == 'Custom') {
        this.displayDays = false;
        this.displaycuston = true;
      }
    }
  }
  dateValueChangedStart(eve) {
    this.AlertMessage = "";
    if (this.form.controls['endDate'].value !== '' && this.form.controls['endDate'].value !== undefined && this.form.controls['endDate'].value !== null) {
      if (new Date(this.form.controls['endDate'].value) < new Date(this.form.controls['startDate'].value)) {
        if (this.form.controls['chosenRecurrence'].value == 'Daily') {
          this.form.patchValue({
            endDate: this.form.controls.startDate.value
          });
        }
        else {
          this.form.patchValue({
            endDate: '',
          });
          this.toastr.error('End date can\'t before start date');
        }
      }
    }
    if (this.form.controls['chosenRecurrence'].value != null) {
      if (this.form.controls['chosenRecurrence'].value == 'Daily') {
        this.form.patchValue({
          endDate: this.form.controls.startDate.value
        });
      }
    }
  }
  providerSelectionChanged(eve) {
    this.AlertMessage = "";
    this.daysSelected = [];
    this.calTemplateDays = [];
   // document.getElementById("caldiv").click();
   //this.reloadcalendar($("#calendar"));
    this.getTemplateDays(moment(new Date()).toDate());
    
  }

  getlocationbasedproviders(event) {
    ;
    this.AlertMessage = "";
    if (event != null && event.source != undefined && event.source.value != null && event.source.value != "" && event.source.value != undefined) {
      this.sharedService.getselectedlocidByrole(Defaults.doctorType, Number(event.source.value)).subscribe(data => {
        this.lstProviders = [];
        this.lstProviders = data;
      });
    }
  }
  displayDays: boolean = false;
  displaycuston: boolean = false;
  save() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      if (this.form.value.chosenRecurrence == 'Custom-Series') {
        if (this.form.value.dayMon == false && this.form.value.dayTue == false && this.form.value.dayWed == false && this.form.value.dayThu == false && this.form.value.dayFri == false && this.form.value.daySat == false && this.form.value.daySun == false) {
          this.toastr.warning('Please select any week day for Custom');
        } else if (this.form.value.dayMon == true || this.form.value.dayTue == true || this.form.value.dayWed == true || this.form.value.dayThu == true || this.form.value.dayFri == true || this.form.value.daySat == true || this.form.value.daySun == true) {
          //this.dialogRef.close(this.form.value);
          this.CheckProvider();
        }
      }
      else if (this.form.value.chosenRecurrence == 'Custom') {
        if (this.daysSelected.length == 0) {
          this.toastr.error("Please select days for which template is to be applied");
          return;
        }
        else {
          this.CheckProvider();
        }
      }
      else {
        // this.dialogRef.close(this.form.value);
        this.CheckProvider();
      }

    } else {
      this.toastr.warning('Enter all mandatory fields')
    }
  }

  CheckProvider() {
    if (this.form.value) {
      ;
      let needToReload: boolean = false;

      let templateCopy = new CalendarTemplate;
      templateCopy = Object.assign({}, this.dialogInput.selectedTemplate);
      templateCopy.calendarTemplateId = this.dialogInput.selectedTemplate.calendarTemplateId;
      templateCopy.calendarTemplateName = this.form.value.newTemplateName;
      if (templateCopy.providerId == this.form.value.chosenProvider && templateCopy.locationId == this.form.value.chosenLocation)
        needToReload = true;
      templateCopy.providerId = this.form.value.chosenProvider;
      templateCopy.locationId = this.form.value.chosenLocation;
      templateCopy.recurrence = this.form.value.chosenRecurrence;
      templateCopy.createdOn = new Date();
      //templateCopy.createdBy = provId;
      templateCopy.createdBy = sessionStorage.getItem("userId").toString();
      templateCopy.modifiedOn = new Date();
      //templateCopy.modifiedBy = provId;
      templateCopy.modifiedBy = sessionStorage.getItem("userId").toString();
      let dayList: string[];
      switch (this.form.value.chosenRecurrence) {
        case 'Monday to Friday':
          dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
          break;
        case 'Daily':
          const d1: Date = moment(this.form.value.startDate).toDate();
          const weekday = d1.getDay();
          dayList = [];
          if (weekday == 1)
            dayList.push('Monday');
          else if (weekday == 2)
            dayList.push('Tuesday');
          else if (weekday == 3)
            dayList.push('Wednesday');
          else if (weekday == 4)
            dayList.push('Thursday');
          else if (weekday == 5)
            dayList.push('Friday');
          else if (weekday == 6)
            dayList.push('Saturday');
          else
            dayList.push('Sunday');
          break;
        case 'Custom-Series':
          dayList = [];
          if (this.form.value.dayMon == true)
            dayList.push('Monday');
          if (this.form.value.dayTue == true)
            dayList.push('Tuesday');
          if (this.form.value.dayWed == true)
            dayList.push('Wednesday');
          if (this.form.value.dayThu == true)
            dayList.push('Thursday');
          if (this.form.value.dayFri == true)
            dayList.push('Friday');
          if (this.form.value.daySat == true)
            dayList.push('Saturday');
          if (this.form.value.daySun == true)
            dayList.push('Sunday');
          break;
        default:
          dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
          break;
      }
      let copytempdays = templateCopy.calendarTemplatesDays;
      let ccalendarTempDays = [];
      if (this.form.value.chosenRecurrence == 'Custom-Series' || this.form.value.chosenRecurrence == 'Daily') {
        for (let i = 0; i < templateCopy.calendarTemplatesDays.length; i++) {
          let ctd = templateCopy.calendarTemplatesDays[i];
          // ctd.CTDayId = 0;
          // ctd.calendarTemplateId = 0;
          // ctd.cDate = new Date();
          let dys = templateCopy.calendarTemplatesDays[i].dayofweek;
          let exdays = dayList;// dys.split(', ');
          if (exdays.length > 0) {
            for (let n = 0; n < exdays.length; n++) {
              if (exdays[n] != '') {
                let cttdy = new CalendarTemplateDay();
                cttdy.CTDayId = 0;
                cttdy.calendarTemplateId = 0;
                cttdy.dayofweek = exdays[n];
                // cttdy.startTime = ctd.startTime;
                // cttdy.endTime = ctd.endTime;
                cttdy.startTime = (this.form.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.form.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(ctd.startTime));
                cttdy.endTime = (this.form.value.endDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.form.value.endDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(ctd.endTime));

                var tempmedexpDate = this.datepipe.transform(this.form.value.startDate, 'yyyy-MM-dd');
                cttdy.cDate = tempmedexpDate != null ? moment(tempmedexpDate).toDate().toDateString() : null;
                if (this.form.value.endDate != null && this.form.value.endDate !== undefined && this.form.value.endDate != '') {
                  var lowrevDate = this.datepipe.transform(this.form.value.endDate, 'yyyy-MM-dd');
                  cttdy.cDateTo = lowrevDate != null ? moment(lowrevDate).toDate().toDateString() : null;
                } else {
                  var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
                  cttdy.cDateTo = lowrevDate != null ? moment(lowrevDate).toDate().toDateString() : null;
                }
                //cttdy.cDate = data.startDate;//ctd.cDate;
                //cttdy.cDateTo =data.endDate;// ctd.cDateTo;
                cttdy.bookinglimit = ctd.bookinglimit;
                //  var numbooking = templateCopy.calendarTemplatesDays.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.startTime == ctd.startTime && c.endTime == ctd.endTime);
                //  cttdy.bookinglimit = numbooking.length;// 1;
                cttdy.visitCategoryId = ctd.visitCategoryId;
                cttdy.visitTypeId = ctd.visitTypeId;
                cttdy.visitText = ctd.visitText == null ? '' : ctd.visitText;
                ccalendarTempDays.push(cttdy);
              }
            }
          }
        }
      }
      else {
        for (let i = 0; i < templateCopy.calendarTemplatesDays.length; i++) {
          let ctd = templateCopy.calendarTemplatesDays[i];
          // ctd.CTDayId = 0;
          // ctd.calendarTemplateId = 0;
          // ctd.cDate = new Date();
          let dys = templateCopy.calendarTemplatesDays[i].dayofweek;
          let exdays = dayList;// dys.split(', ');
          if (this.daysSelected.length > 0) {
            for (let n = 0; n < this.daysSelected.length; n++) {
              if (exdays[n] != '') {
                let cttdy = new CalendarTemplateDay();
                cttdy.CTDayId = 0;
                cttdy.calendarTemplateId = 0;
                const d1: Date = moment(this.daysSelected[n]).toDate();
                const weekday = d1.getDay();
                dayList = [];
                if (weekday == 1)
                  cttdy.dayofweek = 'Monday';
                else if (weekday == 2)
                  cttdy.dayofweek = 'Tuesday';
                else if (weekday == 3)
                  cttdy.dayofweek = 'Wednesday';
                else if (weekday == 4)
                  cttdy.dayofweek = 'Thursday';
                else if (weekday == 5)
                  cttdy.dayofweek = 'Friday';
                else if (weekday == 6)
                  cttdy.dayofweek = 'Saturday';
                else
                  cttdy.dayofweek = 'Sunday';
                // cttdy.dayofweek = exdays[n];
                // cttdy.startTime = ctd.startTime;
                // cttdy.endTime = ctd.endTime;
                // cttdy.startTime = (this.form.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.form.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(ctd.startTime));
                // cttdy.endTime = (this.form.value.endDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.form.value.endDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(ctd.endTime));
                cttdy.startTime = this.daysSelected[n].concat('T').concat(this.dateService.extractTimeFromDateTimeString(ctd.startTime));
                cttdy.endTime = this.daysSelected[n].concat('T').concat(this.dateService.extractTimeFromDateTimeString(ctd.endTime));// (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                // var tempmedexpDate = this.datepipe.transform(this.form.value.startDate, 'yyyy-MM-dd');
                // cttdy.cDate = tempmedexpDate != null ? new Date(tempmedexpDate) : null;
                // if (this.form.value.endDate != null && this.form.value.endDate !== undefined && this.form.value.endDate != '') {
                //   var lowrevDate = this.datepipe.transform(this.form.value.endDate, 'yyyy-MM-dd');
                //   cttdy.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
                // } else {
                //   var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
                //   cttdy.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
                // }
                cttdy.cDate = this.daysSelected[n];
                cttdy.cDateTo = this.daysSelected[n];
                //cttdy.cDate = data.startDate;//ctd.cDate;
                //cttdy.cDateTo =data.endDate;// ctd.cDateTo;
                cttdy.bookinglimit = ctd.bookinglimit;
                //  var numbooking = templateCopy.calendarTemplatesDays.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.startTime == ctd.startTime && c.endTime == ctd.endTime);
                //  cttdy.bookinglimit = numbooking.length;// 1;
                cttdy.visitCategoryId = ctd.visitCategoryId;
                cttdy.visitTypeId = ctd.visitTypeId;
                // cttdy.visitText = ctd.visitText;
                cttdy.visitText = ctd.visitText == null ? '' : ctd.visitText;
                ccalendarTempDays.push(cttdy);
              }
            }
          }
        }
      }
      templateCopy.calendarTemplatesDays = ccalendarTempDays;
      this.schedulerService.insertCalendarTemplate({ ...templateCopy }, 'Copy').subscribe(data => {
        if (data.includes('Provider')) {
          this.AlertMessage = data;
        } else if (data.includes('success')) {
          this.toastr.success("Template copied successfully");
          this.dialogRef.close(this.form.value);
        }
        else {
          this.toastr.warning('Template name already exists.')
        }
        if (needToReload == true) {
          //this.templateList = null;
          //this.mode = 0;
          //this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
        }
      },
        error => {
          //this.alertService.error("There was a problem loading availabilities: "+error);
        });
    }
  }
  AlertMessage: string = '';
  close() {
    this.dialogRef.close();
  }
  dateValueChanged(event) {
    this.AlertMessage = "";
  }

  daysSelected: any[] = [];
  event: any;
  minDate = new Date(2021, 1, 1);
  maxDate = new Date(2050, 1, 31);
  isSelected = (event: any) => {
    // ;
    const date =
      moment(event).toDate().getFullYear() +
      "-" +
      ("00" + (moment(event).toDate().getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + moment(event).toDate().getDate()).slice(-2);
    // if (this.currentmonth != event.getMonth() + 1) {
    //   this.ismonthchange = true;
    //   //  setTimeout(function () {       
    //   this.getTemplateDays(new Date(date));
    //   var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
    //   if (lsl != null && lsl != undefined && lsl.length > 0)
    //     return "selecteds"
    //   // },1000);
    // }
    // else {

    // var tt = new CalendarTemplate();
    // tt.providerId = this.chosenProvider.providerId;
    // tt.locationId = this.chosenLocation.locationId;
    // tt.recurrence = 'Custom';
    // var ttdy = new CalendarTemplateDay();
    // ttdy.cDate = new Date(date);
    // tt.calendarTemplatesDays = [];
    // tt.calendarTemplatesDays.push(ttdy);
    // let calenday = "";
    // const weekday = event.getDay();
    // if (weekday == 1)
    //   calenday = 'Monday';
    // else if (weekday == 2)
    //   calenday = 'Tuesday';
    // else if (weekday == 3)
    //   calenday = 'Wednesday';
    // else if (weekday == 4)
    //   calenday = 'Thursday';
    // else if (weekday == 5)
    //   calenday = 'Friday';
    // else if (weekday == 6)
    //   calenday = 'Saturday';
    // else
    //   calenday = 'Sunday';

    var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    if (rsl != null && rsl != undefined && rsl.length > 0)
      return "selected"

    // var rsl1 = this.editdays.filter(x => x == date);//? "selected" : null;
    // if (rsl1 != null && rsl1 != undefined && rsl1.length > 0)
    //   return null// "selected"

    var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
    if (lsl != null && lsl != undefined && lsl.length > 0)
      return "selecteds"



    // var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    // if (rsl != null && rsl != undefined && rsl.length > 0)
    //   return "selected"
    // else
    return null;
    //}

    //    setTimeout(function () {
    //      this.schService.checkforTemplateday(tt, '', '', calenday).subscribe(result => {
    //       // alert(result);
    //   if (result != 0) {
    //     //alert(result)
    //     // const index = this.daysSelected.findIndex(x => x == date);
    //     // if (index < 0) this.daysSelected.push(date);
    //     // else this.daysSelected.splice(index, 1);
    //     return "selected"
    //   }

    //   var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    //   if (rsl != null && rsl != undefined && rsl.length > 0)
    //     return "selected"
    //   else
    //     return null;
    // }   );
    // // var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    // // if (rsl != null && rsl != undefined && rsl.length > 0)
    // //   return "selected"
    // // else
    // //   return null;
    //    }, 500);
    // this.schedulerService.checkforTemplateday(tt, '', '', calenday).subscribe(result => {
    //   if (result == 1) {
    //     const index = this.daysSelected.findIndex(x => x == date);
    //     if (index < 0) this.daysSelected.push(date);
    //     else this.daysSelected.splice(index, 1);
    //     return "selecteds";
    //   }

    //   var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    //   if (rsl != null && rsl != undefined && rsl.length > 0)
    //     return "selected"
    //   else
    //     return null;
    // }
    // );
    // var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    // if (rsl != null && rsl != undefined && rsl.length > 0)
    //   return "selected"
    // else
    //   return null;
  };

  reloadcalendar(calendar: any) {
    // this.daysSelected=null;
    // this.daysSelected=this.editdays;
    //calendar.activeDate='01/01/2021';
    var d1 = moment(new Date()).toDate();
    d1.setMonth(d1.getMonth() - 1);
    var prevdt = this.datepipe.transform(d1, "yyyy-MM-dd")

    this.select(moment(prevdt).toDate(), calendar);
    this.select(moment(prevdt).toDate(), calendar);
    calendar.updateTodaysDate();
  }

  select(event: any, calendar: any) {
    ;
    if (event != null) {
      const date =
        moment(event).toDate().getFullYear() +
        "-" +
        ("00" + (moment(event).toDate().getMonth() + 1)).slice(-2) +
        "-" +
        ("00" + moment(event).toDate().getDate()).slice(-2);
      // var lsl = this.editdays.filter(x => x == date);//? "selected" : null;
      // if (lsl != null && lsl != undefined && lsl.length > 0) {
      //   //   const index = this.daysSelected.findIndex(x => x == date);
      //   //   if (index < 0) this.daysSelected.push(date);
      //   //   else this.daysSelected.splice(index, 1);
      //   //   calendar.updateTodaysDate();
      //   //   return;
      //   // }        
      //   // else {
      //   const index = this.daysSelected.findIndex(x => x == date);
      //   if (index < 0) {
      //     this.daysSelected.push(date);
      //   }
      //   else {
      //     this.daysSelected.splice(index, 1);
      //   }
      //   return;
      // }
      // else {
      var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
      if (lsl != null && lsl != undefined && lsl.length > 0) {
      }
      else {
        const index = this.daysSelected.findIndex(x => x == date);
        if (index < 0) {
          this.daysSelected.push(date);
        }
        else {
          this.daysSelected.splice(index, 1);
        }
      }
      //  }
      calendar.updateTodaysDate();
    }
    // alert(this.daysSelected);
  }

  monthSelectedd(event) {
    ;
    const date = moment(event.activeDate).toDate();
    this.getTemplateDays(moment(date).toDate());
    event.updateTodaysDate();
  }

  calTemplateDays = [];
  currentmonth = '';
  public async getTemplateDays(currDate): Promise<any> {
    // const date =
    //   currDate.getFullYear() +
    //   "-" +
    //   ("00" + (currDate.getMonth() + 1)).slice(-2) +
    //   "-" +
    //   ("00" + currDate.getDate()).slice(-2);
    var date = this.datepipe.transform(currDate, "yyyy-MM-dd")
    this.currentmonth = String((moment(date).toDate().getMonth() + 1));
    var d = moment(currDate).toDate();
    d.setMonth(d.getMonth() + 1);
    var nextdt = this.datepipe.transform(d, "yyyy-MM-dd")
    // alert(nextdt);
    var d1 = new Date(currDate);
    d1.setMonth(d1.getMonth() - 1);
    var prevdt = this.datepipe.transform(d1, "yyyy-MM-dd")
    //alert(prevdt);
    await this.schedulerService.getTemplateByMonth(this.form.value.chosenProvider, date, this.form.value.chosenLocation)
      .subscribe((events: CalendarTemplateDay[]) => {
        // this.calenderEvents = events;
        events.map(element => {
          const idx = this.calTemplateDays.findIndex(x => x == this.datepipe.transform(element.startTime, "yyyy-MM-dd"));
          if (idx < 0)
            this.calTemplateDays.push(this.datepipe.transform(element.startTime, "yyyy-MM-dd"));
        });

        this.schedulerService.getTemplateByMonth(this.form.value.chosenProvider, nextdt, this.form.value.chosenLocation)
          .subscribe((events: CalendarTemplateDay[]) => {
            // this.calenderEvents = events;
            events.map(element => {
              const idx = this.calTemplateDays.findIndex(x => x == this.datepipe.transform(element.startTime, "yyyy-MM-dd"));
              if (idx < 0)
                this.calTemplateDays.push(this.datepipe.transform(element.startTime, "yyyy-MM-dd"));
            });
          });
        this.schedulerService.getTemplateByMonth(this.form.value.chosenProvider, prevdt, this.form.value.chosenLocation)
          .subscribe((events: CalendarTemplateDay[]) => {
            // this.calenderEvents = events;
            events.map(element => {
              const idx = this.calTemplateDays.findIndex(x => x == this.datepipe.transform(element.startTime, "yyyy-MM-dd"));
              if (idx < 0)
                this.calTemplateDays.push(this.datepipe.transform(element.startTime, "yyyy-MM-dd"));
            });
          });
        // if (this.ismonthchange) {
        //   this.ismonthchange=false;
        //   var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
        //   if (rsl != null && rsl != undefined && rsl.length > 0)
        //     return "selected"

        // var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
        // if (lsl != null && lsl != undefined && lsl.length > 0)
        //   return "selecteds"

        //   return null;

        // }
        return this.calTemplateDays;
      });
  }
}
